export default __webpack_public_path__ + "static/media/JakobOwens-img.7ca437e6.jpeg";